import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Optional, Inject, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { datePickerMinDate, noWhitespaceInRequiredValidator } from '../../../shared/constants';
import { noop } from 'jquery';
import { NavbarComponent } from '../../../navbar/navbar.component';
import Swal from 'sweetalert2';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { environment } from '../../../../environments/environment';
import moment from 'moment';
import { startWith } from 'rxjs';

@Component({
	selector: 'app-regularization-form',
	templateUrl: './regularization-form.component.html',
	styleUrl: './regularization-form.component.scss'
})
export class RegularizationFormComponent {
	File_Storage_URL = environment.File_Storage_URL;
	requiredValidator = Validators.required;
	moduleForm: FormGroup = this.formBuilder.group({
		emp_code: [null, [this.requiredValidator]],
		date: [null, [this.requiredValidator]],
		in_date: [null, [this.requiredValidator]],
		in_time: [null, [this.requiredValidator]],
		out_date: [null, [this.requiredValidator]],
		out_time: [null, [this.requiredValidator]],
		work_time: [{ value: null, disabled: true }, [this.requiredValidator]],
		reason: [null, [this.requiredValidator]],
		is_approved: [false],
		weekly_off: [false],
		wfh: [false],
	});
	showLoader = false;
	pageLoading1 = false;
	uId: any = null;
	@Input() userList: any[] = [];
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	details: any = null;
	minDate = datePickerMinDate;
	modalId = "regularizationModal" + this.getRandom5DigitNumber();
	isAssignee = true;
	getRandom5DigitNumber() {
		return Math.floor(Math.random() * 90000) + 10000;
	}

	constructor(private cd: ChangeDetectorRef, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.f.in_date.valueChanges.pipe(startWith(this.f.in_date.value)).subscribe(_ => this.calculateWorkDuration());
		this.f.in_time.valueChanges.pipe(startWith(this.f.in_time.value)).subscribe(_ => this.calculateWorkDuration());
		this.f.out_date.valueChanges.pipe(startWith(this.f.out_date.value)).subscribe(_ => this.calculateWorkDuration());
		this.f.out_time.valueChanges.pipe(startWith(this.f.out_time.value)).subscribe(_ => this.calculateWorkDuration());
	}

	initForm(obj: any) {
		this.uId = obj.id || null;
		if (this.uId) {
			this.details = obj;
			if (this.details.emp_code.emp_code) {
				this.navbar.getValueFromUserList(this.details.emp_code.emp_code, "emp_code").then((val) => {
					this.f.emp_code.setValue(val);
				});
			}
			this.f.date.setValue(this.apiService.getDateFromDateString(this.details.date, 'DD-MM-YYYY'));
			this.f.in_date.setValue(this.apiService.getDateFromDateString(this.details.in_date, 'DD-MM-YYYY'));
			this.f.in_time.setValue(this.apiService.getTimeFromTimeString(this.details.in_time));
			this.f.out_date.setValue(this.apiService.getDateFromDateString(this.details.out_date, 'DD-MM-YYYY'));
			this.f.out_time.setValue(this.apiService.getTimeFromTimeString(this.details.out_time));
			this.f.work_time.setValue(this.apiService.getTimeFromTimeString(this.details.work_time));
			this.f.reason.setValue(this.details.reason);
			this.f.is_approved.setValue(this.details.is_approved);
			this.f.weekly_off.setValue(this.details.weekly_off);
			this.f.wfh.setValue(this.details.wfh);
		} else {
			this.moduleForm.reset();
			if (obj.date) {
				this.f.date.setValue(obj.date);
			}
			if (obj.emp_code) {
				this.f.emp_code.setValue(obj.emp_code);
			}
			this.f.is_approved.setValue(false);
			this.f.weekly_off.setValue(false);
			this.f.wfh.setValue(false);
			this.formSubmitted = false;
			this.uId = null;
		}
		if (!this.navbar.hasRegularizationAccess()) {
			this.f.is_approved.disable();
			this.f.emp_code.disable();
			this.f.weekly_off.disable();
			this.f.wfh.disable();
		} else {
			this.f.is_approved.enable();
			this.f.emp_code.enable();
			this.f.weekly_off.enable();
			this.f.wfh.enable();
		}
		this.f.date.disable();
		this.changedWeeklyOf_or_WorkFromHome();
		this.isAssignee = obj.isAssignee;
		if (this.isAssignee) {
			this.f.emp_code.disable();
			this.f.is_approved.disable();
		}
		this.openModal();
	}

	get f() { return this.moduleForm.controls; }

	clearForm() {
		this.uId = null;
		this.moduleForm.reset();
		this.formSubmitted = false;
		this.cleared.emit();
		$("#" + this.modalId).modal("hide");
	}

	openModal() {
		$("#" + this.modalId).modal("show");
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
					noop;
				}
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			emp_code: this.f.emp_code.value,
			date: this.apiService.getDateStringFromDate(this.f.date.value, 'YYYY-MM-DD'),
			in_date: this.apiService.getDateStringFromDate(this.f.in_date.value, 'YYYY-MM-DD'),
			in_time: this.apiService.getTimeStringFromTime(this.f.in_time.value),
			out_date: this.apiService.getDateStringFromDate(this.f.out_date.value, 'YYYY-MM-DD'),
			out_time: this.apiService.getTimeStringFromTime(this.f.out_time.value),
			work_time: this.apiService.getTimeStringFromTime(this.f.work_time.value),
			reason: this.f.reason.value,
			is_approved: this.f.is_approved.value,
			weekly_off: this.f.weekly_off.value,
			wfh: this.f.wfh.value,
		};
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateRegularization(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.cd.detectChanges();
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				this.cd.detectChanges();
				if (error.status == 401) { return }
				let errorMsg = error.error;
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	calculateWorkDuration() {
		const mStart = moment(this.apiService.getDateStringFromDate(this.f.in_date.value, 'YYYY-MM-DD') + " " + this.apiService.getTimeStringFromTime(this.f.in_time.value), "YYYY-MM-DD HH:mm:ss");
		const mEnd = moment(this.apiService.getDateStringFromDate(this.f.out_date.value, 'YYYY-MM-DD') + " " + this.apiService.getTimeStringFromTime(this.f.out_time.value), "YYYY-MM-DD HH:mm:ss");
		const duration = moment.duration(mEnd.diff(mStart));
		const hours = Math.floor(duration.asHours());
		const minutes = duration.minutes();
		const seconds = duration.seconds();
		this.f.work_time.setValue({ hour: hours, minute: minutes, second: seconds });
	}

	isRequired(field: string) {
		return this.f[field].hasValidator(this.requiredValidator);
	}

	changedWeeklyOf_or_WorkFromHome(field: any = null) {
		if (field) {
			if (field == "wo") {
				this.f.wfh.setValue(false);
			} else if (field == "wfh") {
				this.f.weekly_off.setValue(false);
			}
		}
		if (this.f.weekly_off.value || this.f.wfh.value) {
			this.f.in_date.setValidators(null);
			this.f.in_time.setValidators(null);
			this.f.out_date.setValidators(null);
			this.f.out_time.setValidators(null);
			this.f.work_time.setValidators(null);
			this.f.reason.setValidators(null);
		} else {
			this.f.in_date.setValidators(this.requiredValidator);
			this.f.in_time.setValidators(this.requiredValidator);
			this.f.out_date.setValidators(this.requiredValidator);
			this.f.out_time.setValidators(this.requiredValidator);
			this.f.work_time.setValidators(this.requiredValidator);
			this.f.reason.setValidators(this.requiredValidator);
		}
		this.f.in_date.updateValueAndValidity();
		this.f.in_time.updateValueAndValidity();
		this.f.out_date.updateValueAndValidity();
		this.f.out_time.updateValueAndValidity();
		this.f.work_time.updateValueAndValidity();
		this.f.reason.updateValueAndValidity();
	}
}
